// Copyright (c) 2022 Deere & Company

export const trimToLength = (str = '', len) => {

    let trimmedString;

    if (str.length > len) {

        trimmedString = str.substring(0, length);

    } else {

        trimmedString = str;

    }

    return trimmedString;

};

export const limitMaxValue = (num = 0, maxValue) => {

    let limitedNum;

    if (num > maxValue) {

        limitedNum = maxValue;

    } else {

        limitedNum = num;

    }

    return limitedNum;

};



// WEBPACK FOOTER //
// ./src/shared/services/fix-data.js